(function($, undefined) {
	
	'use strict';
    var stickyFooter;
    var stickyFooterMargin;
    var cancelTransactionBtn;
    var eventSelect;
    var directEntranceCheck;
    var sendEmailCheck;
    var continueStep2Btn;
    var continueStep3Btn;
    var saveNewDeliveryBtn;
    var saveNewSendByEmailBtn;
    var submitStepPaymentBtn;
    var toggleDirectEntranceBtn;
    var error = false;
    
    var sessionDirectEntrance = "virtualCashierDirectEntrance";
    var sessionSendByEmail = "virtualCashierSendByEmail";
    var sessionDeliveryProducts ="virtualCashierDeliveryProducts";
    


    var setFooterMargin = function() {
        stickyFooterMargin.css('margin-top', stickyFooter.height() + 20);
    };

    var cancelTransaction = function() {
        var t = $(this);

        ajax('/action/epAddCart?clear=true&ajax=true', function(response){
            window.location.href = t.attr('data-forward');
        }, true);
    };
    
    var saveDirectEntrance = function(){
        var t = $(this);        
        session.save(sessionDirectEntrance, t.is(":checked"), function () {});    
    };
    var saveSendByEmail = function(){
        var t = $(this);        
        session.save(sessionSendByEmail, t.is(":checked"), function () {});    
        if(!t.is(":checked")){
            $(".js-form-error-message.fields").slideUp();            
            $(".virtual-cash-resp-wrap .form-input.required").each(function(){
                session.save(sessionSendByEmail + $(this).attr("name"), null, function () {});   
            });
        }
    };
    
    var validateStep1 = function(e){
        e.preventDefault();        
        var t = $(this);
        t.addClass("disabled");
        var products = t.attr("data-products"); 
        var onlyProductsLinked = t.attr("data-onlyLinkedProducts"); 
        var ticketsInCart = 0;
        error = false;

        // count tickets in cart for iframe
        $('.virtual-cash-ticket-ctn .event-one-ticket-ctn > .event-one-ticket-select-qty').each(function() {
            var val = parseInt($(this).find('.event-ticket-select').val());
            ticketsInCart = ticketsInCart + val;
        });

        if (products === 'false' || onlyProductsLinked === 'true') {// cannot skip step1 if no products
            var counter = 0;
            $(".virtual-cash-ticket-ctn").each(function () {
                if($(this).find(".event-ticket-select").length !== 0){
                    counter += parseInt($(this).find(".event-ticket-select").val());
                }
            });
            if (counter === 0) {
                error = true;
                $(".virtual-cash-step-1-warning-1").slideDown();
                
                if ($(".virtual-cash-step-1-warning-1").length > 0) {  
                    $('html, body').animate({
                        scrollTop: $(".virtual-cash-step-1-warning-1").offset().top
                    }, 2000);
                }
                //Select at least one ticket
            } else {
                $(".virtual-cash-step-1-warning-1").slideUp();                
            }
        }
        if(sendEmailCheck.is(":checked") || (t.closest('.iframe-wrapper:not(.products-iframe)').length > 0 && (products === 'false' || onlyProductsLinked === 'true' || ticketsInCart !== 0))){
            var req = false;
            var l = $(".virtual-cash-resp-wrap .form-input.required").length;
            var counter = 0;
            $(".virtual-cash-resp-wrap .form-input.required").each(function(){
                if($(this).val().trim() === '' || $(this).hasClass("error")){
                    $(this).addClass("error");
                    error = true;
                    req = true;
                    $(".js-form-error-message.fields").slideDown();
                    t.removeClass("disabled");
                } else {
                    if (t.closest('.iframe-wrapper').length > 0) {
                        session.save(sessionSendByEmail, true, function () {});   
                    }
                    session.save(sessionSendByEmail+$(this).attr("name"), encodeURIComponent($(this).val()), function () {
                        counter++;
                        if(counter === l && !error){
                            window.location = t.attr("href");
                        }
                    });
                }
            });
            if(!req){
                $(".js-form-error-message.fields").slideUp();                
            } else if ($(".error:eq(0)").length > 0) {  
                $('html, body').animate({
                    scrollTop: $(".error:eq(0)").offset().top - 90
                }, 2000);
            }
        } else {            
            $(".js-form-error-message.fields").slideUp(); 
            if (!error){
                window.location = t.attr("href");
            } else {                
                t.removeClass("disabled");
            }
        }
    };
    
    var validateStep2 = function(e){
        e.preventDefault();
        var t = $(this);
        var table = $(".payment-process-table");
        var products = !(table.find(".payment-process-table-row:not(.template)").length === 1);
        var ticketsInCart = t.attr("data-ticketsInCart");
        var delivery;
        var pickup1;
        var pickup2;
        t.addClass("disabled");
        error = false;

        if (products) {
            delivery = $(".payment-process-radio[value = '0']").is(":checked");
            pickup1 = $(".payment-process-radio[value = '1']").is(":checked");
            pickup2 = $(".payment-process-radio[value = '2']").is(":checked");

            if ($('.iframe-wrapper').hasClass('products-iframe') || $('.iframe-wrapper').find('input[name=email]').length > 0) {
                if ($('.iframe-wrapper').hasClass('products-iframe')) {
                    delivery = true;
                }
                session.save(sessionSendByEmail, true, function () {}); 
                session.save(sessionSendByEmail+'email', encodeURIComponent($('.iframe-wrapper').find('input[name=email]').val()), function () {}); 
            }
            
            if (delivery) {
                var req = false;
                var l = $(".virtual-cash-inputs-ctn .form-input:not(select:not([name = 'country'])), .virtual-cash-inputs-ctn .selected-province").length;
                var counter = 0;
                $(".virtual-cash-inputs-ctn .form-input:not(select:not([name = 'country'])), .virtual-cash-inputs-ctn .selected-province").each(function () {
                    if ($(this).attr("name") !== undefined) {
                        if ($(this).hasClass("required") && $(this).val().trim() === '') {
                            $(this).addClass("error");
                            error = true;
                            req = true;
                            $(".js-form-error-message.fields").slideDown();
                            t.removeClass("disabled");
                        } else {
                            $(this).removeClass("error");
                            session.save(sessionDeliveryProducts + $(this).attr("name"), encodeURIComponent($(this).val()), function () {
                                counter++;
                                if (counter === l && !error) {
                                    window.location = t.attr("href");
                                }
                            });
                        }
                    }
                });
                if (!req) {
                    $(".js-form-error-message.fields").slideUp();
                } else if ($(".error:eq(0)").length > 0) {  
                    $('html, body').animate({
                        scrollTop: $(".error:eq(0)").offset().top - 90
                    }, 2000);
                }
            } else if (!pickup1 && !pickup2 && !delivery) {
                $(".virtual-cash-step-2-warning-1").slideDown();
                error = true;
                t.removeClass("disabled");
                if ($(".virtual-cash-step-2-warning-1").length > 0) {      
                    $('html, body').animate({
                        scrollTop: $(".virtual-cash-step-2-warning-1").offset().top
                    }, 2000);
                }
            }
        }
        if (!products && ticketsInCart === '0'){
            error = true;
            $(".virtual-cash-step-2-warning-2").slideDown();
            if ($(".virtual-cash-step-2-warning-2").length > 0) {  
                $('html, body').animate({
                    scrollTop: $(".virtual-cash-step-2-warning-2").offset().top
                }, 2000);
            }
            t.removeClass("disabled");
        } else {
            $(".virtual-cash-step-2-warning-2").slideUp();

            if (!error && (!products || (products && (pickup1 || pickup2 || delivery)))) {
                window.location = t.attr("href");
            }
        }
    };
    
    var saveNewDeliveryAddr = function () {
        var req = false;
        var n = "";
        var addr1 = "";
        var addr2 = "";
        var country = "";
        var fn = "";
        var ln = "";
        var street = "";
        var street2 = "";
        var city = "";
        var province = "";
        var zip = "";
        var ctn = $(this).closest(".virtual-cash-address-box-inputs-ctn");
        ctn.find(".form-input, .selected-province").each(function () {
            var name = $(this).attr("name");
            var val = $(this).val().trim();
            if (name !== undefined) {
                if (name != 'street2' && $(this).hasClass("required") && val === '') {
                    $(this).addClass("error");
                    req = true;
                    error = true;
                    $(".js-form-error-message.fields").slideDown();
                } else {
                    $(this).removeClass("error");
                    session.save(sessionDeliveryProducts + name, encodeURIComponent(val), function () {});
                    if(name === 'firstName') {
                        n = val;
                        fn = val;
                    }
                    if (name === 'lastName') {
                        n += " " + val;
                        ln = val;
                    }
                    if (name === 'street') {
                        addr1 = val;
                        street = val;
                    }
                    if (name === 'street2' && val !== '') {
                        addr1 += ", " + val;
                        street2 = val;
                    }
                    if (name === 'city') {
                        addr2 = val;
                        city = val;
                    }
                    if (name === 'province') {
                        addr2 += ", " + val;
                        province = val;
                    }
                    if (name === 'zip') {
                        addr2 += " " + val;
                        zip = val;
                    }
                    if (name === 'country') {
                        country = val;
                    }
                }
            }
        });
        if (error && $(".error:eq(0)").length > 0) {  
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
        }
        if (!req) {
            $(".js-form-error-message.fields").slideUp();
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-name").text(n);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-addr1").text(addr1);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-addr2").text(addr2);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-country").text(country);
            
            $(".form-virtual-cashier-del-fn").val(fn);
            $(".form-virtual-cashier-del-ln").val(ln);
            $(".form-virtual-cashier-del-street").val(street);
            $(".form-virtual-cashier-del-street2").val(street2);
            $(".form-virtual-cashier-del-city").val(city);
            $(".form-virtual-cashier-del-province").val(province);
            $(".form-virtual-cashier-del-zip").val(zip);
            $(".form-virtual-cashier-del-country").val(country);
        }        
    };
    
    var saveNewSendByEmail = function () {
        var req = false;
        var n = "";
        var email = "";
        var fn = "";
        var ln = "";
        var ctn = $(this).closest(".virtual-cash-address-box-inputs-ctn");
        ctn.find(".form-input[name != ''], .selected-province").each(function () {
            var name = $(this).attr("name");
            var val = $(this).val().trim();
            if (name !== undefined) {
                if ($(this).hasClass("required") && val === '') {
                    $(this).addClass("error");
                    req = true;
                    $(".js-form-error-message.fields").slideDown();
                } else {
                    $(this).removeClass("error");
                    session.save(sessionSendByEmail + name, encodeURIComponent(val), function () {
                    });
                    if (name === 'buyerFirstName') {
                        n = val;
                        fn = val;
                    }
                    if (name === 'buyerLastName') {
                        n += " " + val;
                        ln = val;
                    }
                    if (name === 'email') {
                        email = val;
                    }
                }
            }
        });
        if (!req) {
            $(".js-form-error-message.fields").slideUp();
            $(".virtual-cash-send-by-email-ctn").find(".virtual-cash-send-by-email-name").text(n);
            $(".virtual-cash-send-by-email-ctn").find(".virtual-cash-send-by-email-email").text(email);
            $(".form-virtual-cashier-email").val(email);
            $(".form-virtual-cashier-fn").val(fn);
            $(".form-virtual-cashier-ln").val(ln);
        } else if ($(".error:eq(0)").length > 0) {
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
        }    
    };

    var submitPaymentForm = function(){
        var t = $(this);
        error = false;
        t.addClass("disabled");
        if($(".vc-payment-box-inputs-ctn").length !== 0){
            $(".vc-payment-box-inputs-ctn .form-input.required").each(function(){
                var val = $(this).val().trim();
                if(val === ''){
                    error = true;
                    $(this).addClass("error");
                    t.removeClass("disabled");
                }
            });
        } 
        // if step 3 delivery chosen, validate/save address
        if ($('.virtual-cash-address-box-merch:not(.hide)').length > 0 && ($('.virtual-cash-address-box-merch').find('.virtual-cash-address-box-inputs-ctn').css('display') === 'block' || $('.virtual-cash-address-box-merch').find('.form-input.required[val=""]').length > 0)) {
            saveNewDeliveryBtn.trigger('click');
            t.removeClass("disabled");
        }
        if (!error) {
            t.addClass("disabled");
            $(".virtual-cash-form").submit();
        } else if ($(".error:eq(0)").length > 0) {
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
            $(".js-form-error-message.fields").slideDown();
        }
    };
    
    var toggleDirectEntrance = function(){
        var t = $(this);
        var url = "/action/epQR";
        url += "?validate=" + t.attr("data-1");
        url += "&paymentToken=" + t.attr("data-2");
        url += "&scan=" + (t.attr("data-3") !== "true");
        
        ajax(url, function(response){
            if(response.indexOf("success") !== -1){
                t.toggleClass("checked");
                t.attr("data-3", (t.attr("data-3") !== "true"));
            }
        }, true);
    };

	var init = function () {  
        stickyFooter = $('.virtual-cash-steps-outer-ctn');
        stickyFooterMargin = $('.virtual-cash-steps-margin');
        cancelTransactionBtn = $('.virtual-cash-cancel-btn');
        eventSelect = $('.virtual-cash-select-event');
        directEntranceCheck = $('.check-direct-entrance input[name="directEntrance"]');
        sendEmailCheck = $('.check-send-by-email input[name="sendByEmail"]');
        continueStep2Btn = $('.virtual-cashier-continue-step2');
        continueStep3Btn = $('.virtual-cashier-continue-step3');
        saveNewDeliveryBtn = $('.save-new-delivery-address-btn');
        saveNewSendByEmailBtn = $('.save-new-send-by-email-btn');
        submitStepPaymentBtn = $('.virtual-cashier-submit-form');
        toggleDirectEntranceBtn = $('.vc-confirm-step-btn.entrance');

        cancelTransactionBtn.click(cancelTransaction);
        eventSelect.click(cancelTransaction);
        directEntranceCheck.click(saveDirectEntrance);
        sendEmailCheck.click(saveSendByEmail);
        continueStep2Btn.click(validateStep1);
        continueStep3Btn.click(validateStep2);
        saveNewDeliveryBtn.click(saveNewDeliveryAddr);
        saveNewSendByEmailBtn.click(saveNewSendByEmail);
        submitStepPaymentBtn.click(submitPaymentForm);
        toggleDirectEntranceBtn.click(toggleDirectEntrance);
        setFooterMargin();
        $(window).resize(function() {
            setFooterMargin();
        });
        if (window.location.href.indexOf("fail") > -1) {
            $(".vc-payment-box-inputs-fail").slideDown();
        }
	};
	
    	
	$(window).on("load",function(){
        init();
    });
})(jQuery);
